import readFile from './readFile';

const resizeImage = (imgUrl, type, maxWidth, maxHeight) => {
  return new Promise((resolve, reject) => {
    const img = document.createElement('img');
    img.onerror = reject;
    img.onload = function (event) {
      const { width, height } = img;
      if (width === 0 && height === 0) return reject();
      if (width <= maxWidth && height <= maxHeight) {
        console.log(
          `The size is smaller the max, actual size: ${width}/${height}, max size: ${maxWidth}/${maxHeight}`
        );
        resolve(imgUrl);
      } else {
        let newWidth;
        let newHeight;

        if (width > height) {
          newHeight = height * (maxWidth / width);
          newWidth = maxWidth;
        } else {
          newWidth = width * (maxHeight / height);
          newHeight = maxHeight;
        }

        console.log(
          `The size is bigger then max, actual size: ${width}/${height}, max size: ${maxWidth}/${maxHeight}, new size: ${newWidth}/${newHeight}`
        );

        const canvas = document.createElement('canvas');
        canvas.width = newWidth;
        canvas.height = newHeight;
        const ctx = canvas.getContext('2d');
        // Actual resizing
        ctx.drawImage(img, 0, 0, newWidth, newHeight);
        resolve(canvas.toDataURL(type));
      }
    };
    img.src = imgUrl;
  });
};

const resizeImageFile = (file, width, height) => {
  return readFile(file).then((base64Image) =>
    resizeImage(base64Image, file.type, width, height)
  );
};

const resizeImageFiles = (files, width, height) =>
  Promise.allSettled(
    Array.from(files).map((f) => resizeImageFile(f, width, height))
  );

export default resizeImageFile;
export { resizeImage, resizeImageFiles };
